function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 1 0rem;\n  flex-direction: column;\n  overflow: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ArrowNext from './Icons/ArrowNext';
import { px2rem, size, padding, margin, font, getSpacing, getDisplay } from '../utils/helpers';
var Label = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      truncate = _ref.truncate,
      hasSublabel = _ref.hasSublabel;
  var colors = theme.colors,
      text = theme.text,
      itemList = theme.itemList;
  var label = itemList.label;
  return _extends({
    overflow: truncate && 'hidden',
    textOverflow: truncate && 'ellipsis',
    whiteSpace: truncate && 'nowrap',
    wordBreak: !truncate && 'break-word'
  }, padding({
    paddingTop: label.paddingTop,
    paddingBottom: !hasSublabel ? label.paddingBottom : 0
  }), font(_extends({}, text.shared.normal, text.standard.xlarge)), {
    color: colors.black
  });
});
var SubLabel = styled.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme,
      truncate = _ref2.truncate;
  var colors = theme.colors,
      text = theme.text,
      itemList = theme.itemList;
  var subLabel = itemList.subLabel;
  return _extends({
    overflow: truncate && 'hidden',
    textOverflow: truncate && 'ellipsis',
    whiteSpace: truncate && 'nowrap',
    wordBreak: !truncate && 'break-word'
  }, font(_extends({}, text.shared.normal, text.mention.xlarge)), {
    color: colors.grey3
  }, padding(subLabel));
});
var Container = styled.a(_templateObject3(), function (_ref3) {
  var _hoverFocus, _active;

  var theme = _ref3.theme;
  var colors = theme.colors,
      itemList = theme.itemList;
  var container = itemList.container,
      icon = itemList.icon;
  return {
    display: 'flex',
    alignItems: 'center',
    maxWidth: px2rem(container.maxWidth),
    height: '100%',
    textDecoration: 'none',
    transition: 'outline-offset .2s ease-in-out',
    outlineOffset: px2rem(container.outlineOffset),
    'svg:first-child': _extends({}, size(icon), margin(icon)),
    '&:hover, &:focus': (_hoverFocus = {
      'svg:first-child': {
        path: {
          fill: colors.grey3
        }
      }
    }, _hoverFocus[Label + "," + SubLabel] = {
      color: colors.grey3,
      textDecoration: 'underline',
      textDecorationColor: colors.grey3
    }, _hoverFocus),
    '&:focus': {
      outline: px2rem(container.outlineWidth) + " solid " + colors[container.outlineColor],
      outlineOffset: 0
    },
    '&:active': (_active = {
      'svg:first-child': {
        path: {
          fill: colors.primary1
        }
      }
    }, _active[Label + "," + SubLabel] = {
      color: colors.primary1,
      textDecoration: 'underline',
      textDecorationColor: colors.primary1
    }, _active)
  };
}, getSpacing, getDisplay);
var ItemContainer = styled.div(_templateObject4(), function (_ref4) {
  var theme = _ref4.theme;
  var colors = theme.colors,
      itemList = theme.itemList;
  var itemContainer = itemList.itemContainer,
      arrow = itemList.arrow;
  return {
    display: 'flex',
    flex: '1 1 0rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    minHeight: px2rem(itemContainer.minHeight),
    minWidth: 0,
    borderBottom: "1px solid " + colors.grey4,
    'svg:last-child': _extends({}, size(arrow), margin(arrow)),
    // IE11 fix https://vinceumo.github.io/devNotes/CSS/bug-ie-flexbox-min-height/
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      '&:after': {
        content: '""',
        minHeight: 'inherit'
      }
    }
  };
});
var ItemTextContainer = styled.div(_templateObject5());

function ItemList(props) {
  var id = props.id,
      icon = props.icon,
      iconAttrs = props.iconAttrs,
      label = props.label,
      subLabel = props.subLabel,
      truncateLabel = props.truncateLabel,
      truncateSubLabel = props.truncateSubLabel,
      rest = _objectWithoutPropertiesLoose(props, ["id", "icon", "iconAttrs", "label", "subLabel", "truncateLabel", "truncateSubLabel"]);

  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Container, _extends({
    id: id
  }, rest), icon && React.createElement(icon, _extends({}, iconAttrs)), /*#__PURE__*/React.createElement(ItemContainer, null, /*#__PURE__*/React.createElement(ItemTextContainer, null, /*#__PURE__*/React.createElement(Label, {
    id: id + "-label",
    truncate: truncateLabel,
    hasSublabel: subLabel,
    title: truncateLabel && label
  }, label), subLabel && /*#__PURE__*/React.createElement(SubLabel, {
    id: id + "-sublabel",
    truncate: truncateSubLabel
  }, subLabel)), /*#__PURE__*/React.createElement(ArrowNext, {
    color: "primary1"
  }))));
}

ItemList.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  iconAttrs: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  truncateLabel: PropTypes.bool,
  truncateSubLabel: PropTypes.bool
} : {};
ItemList.defaultProps = {
  icon: undefined,
  iconAttrs: undefined,
  subLabel: undefined,
  truncateLabel: false,
  truncateSubLabel: false
};
export default ItemList;